import {
  Modal,
  Button,
  Divider,
  Layout,
  Input,
  Select,
  Checkbox,
  InputNumber,
  DatePicker,
} from "antd";
import * as React from "react";
import { useState } from "react";
import { Formik } from "formik";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { AddCourseBenefitsIcon } from "./AddCourseBenefitsIcon";
import { AddCourseMediaFiles } from "./AddCourseMediaFiles";
import { AddCourseBanner } from "./AddCourseBanner";
import { AddCourseIntroMedia } from "./AddCourseIntroMedia";
import { AddCoursePrimaryMedia } from "./AddCoursePrimaryMedia";
import { PictureOutlined, DeleteFilled } from "@ant-design/icons";
import { listAllDropDownLanguage } from "../../Graphs/Language/listAllDropDownLanguage";
import { listAllDropDownCategory } from "../../Graphs/Category/listAllDropDownCategory";
import { listSubCategoryFromCategory } from "../../Graphs/SubCategory/listSubCategoryFromCategory";
import moment from "moment";
import {
  COURSE_BANNER_PREVIEW_PATH,
  COURSE_BENEFIT_PREVIEW_PATH,
  COURSE_PRIMARY_PREVIEW_PATH,
  COURSE_INTRO_PREVIEW_PATH,
  COURSE_BANNER_UPLOAD_PATH,
} from "../../constant/comman";
import MediaItem from "../Media/MediaItem";
// import EditorField from "../common/EditorField";
import CKEditorField from "../common/CKEditorField";
import { checkPermission } from "../AdminUser/CheckAdminPermission";
import { CustomModal } from "../common/CustomModal";
import { CustomSelect } from "../common/CustomSelect";
import { CustomDatePicker } from "../common/CustomDatePicker";
import { listCertificateTemplates } from "../../Graphs/CertificateTemplate";

const { Content } = Layout;
const { TextArea } = Input;
const Option = Select.Option;

var amenities = [];

export class AddCourse extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.state = {
      data: [],
      viewBannerModal: false,
      viewIntroModal: false,
      viewPrimaryModal: false,
      viewMediaModal: false,
      viewBenefitIconModal: false,
      isLoading: false,
      visible: false,
      selectedCategoryType: "",
      selectedDiffLevel: "",
      selectedValidity: "",
      selectedValidityDate: null,
      validityOpen: false,
      selectedSubCategoryType: [],
      isPaid: false,
      isRestricted: false,
      isCertified: false,
      certificateTemplates: [],
      selectedCertificateTemplateId: null,
      isFeatured: false,
      categoryList: [],
      skills: [],
      languages: [],
      inputFields: [],
      benefits: [],
      mediaFields: [],
      media: [],
      primary: [],
      banner: [],
      intro: [],
      selectedLanguage: [],
      allSubCategories: [],
      isShouldComponentUpdate: false,
      longDescription: null,
      errors: {},
    };
  }

  input;
  selectedColorType = "";
  selctedColorKey = "";
  src = [];
  mediaSrc = [];
  skills = [];
  languages = [];
  allLanguages = [];
  allCategories = [];
  allSubCategories = [];
  bannerSrc = {};
  viewPrimaryModalRef;
  viewBannerModalRef;
  viewIntroModalRef;
  viewMediaModalRef;
  viewBenefitIconModalRef;

  difficultyLevelTypes = [
    { value: "Beginner", label: "Beginner" },
    { value: "Intermediate", label: "Intermediate" },
    { value: "Master", label: "Master" },
  ];

  courseValididyTypes = [
    { value: "3", label: "3 Month" },
    { value: "6", label: "6 Month" },
    { value: "12", label: "12 Month" },
  ];

  async componentDidMount() {
    const { authToken } = this.props;

    try {
      let tplData = await listCertificateTemplates(authToken);
      if (tplData && tplData.data) {
        const defaultTpl = tplData.data.find((t) => t.is_default);
        this.setState({
          certificateTemplates: tplData.data,
          selectedCertificateTemplateId: defaultTpl ? defaultTpl._id : (tplData.data[0]?._id || null),
        });
      }
    } catch (err) {
      console.error("Error fetching certificate templates:", err);
    }

    let languageData = await listAllDropDownLanguage(authToken);

    if (languageData.data && languageData.data.length >= 1) {
      languageData.data.forEach((data) => {
        this.allLanguages.push({
          value: data._id,
          label: data.name,
        });
      });
    }

    let categoryData = await listAllDropDownCategory(authToken);

    if (categoryData.data && categoryData.data.length >= 1) {
      categoryData.data.forEach((data) => {
        this.allCategories.push({
          value: data._id,
          label: data.name,
        });
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isShouldComponentUpdate } = nextState;
    console.log("!!!!!!!!!!!!!update 1", nextState);
    if (!isShouldComponentUpdate) {
      this.selectedColorType = "";
      this.src = [];
      this.mediaSrc = [];
      this.bannerSrc = {};
    }

    return true;
  }

  validateForm(values) {
    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!values.author) {
      errors.author = "Author is required";
    }

    if (!values.total_time) {
      errors.total_time = "Total Time is required";
    } else if (!/^\d+$/.test(values.total_time)) {
      errors.total_time = "Total Time must be an integer";
    }
    if (
      values.passing_marks !== undefined &&
      values.passing_marks !== "" &&
      !(values.passing_marks >= 0 && values.passing_marks <= 100)
    ) {
      errors.passing_marks = "Passing marks must be between 0 and 100.";
    }
    if (
      this.state.isRestricted &&
      (!values.age_restriction_count || values.age_restriction_count <= 0)
    ) {
      errors.age_restriction_count = "Restricted Age is required";
    }

    if (this.state.isPaid && (!values.price || values.price <= 0)) {
      errors.price = "Price is required";
    }

    console.log("Validating errors -- ", errors);

    return errors;
  }

  handleSubmit = async (values, action) => {
    const {
      media,
      primary,
      banner,
      intro,
      longDescription,
      selectedCategoryType,
      selectedSubCategoryType,
      isPaid,
      isRestricted,
      isCertified,
      isFeatured,
      selectedDiffLevel,
      selectedValidity,
      selectedLanguage,
      skills,
      benefits,
      errors,
    } = this.state;

    const dummyErrors = { ...errors };

    dummyErrors.selectedCategoryType = "";
    dummyErrors.selectedSubCategoryType = "";
    dummyErrors.selectedDiffLevel = "";
    dummyErrors.selectedLanguage = "";
    dummyErrors.skills = "";
    dummyErrors.primary = "";
    dummyErrors.banner = "";
    // dummyErrors.intro = "";
    dummyErrors.media = "";
    dummyErrors.benefits = [];

    let isValidation = false;

    if (!selectedCategoryType) {
      isValidation = true;
      dummyErrors.selectedCategoryType = "Please select category";
    }

    if (!selectedSubCategoryType || selectedSubCategoryType.length <= 0) {
      isValidation = true;
      dummyErrors.selectedSubCategoryType = "Please select sub category";
    }

    if (!selectedValidity) {
      isValidation = true;
      dummyErrors.selectedValidity = "Please select validity";
    }

    if (!selectedDiffLevel) {
      isValidation = true;
      dummyErrors.selectedDiffLevel = "Please select difficulty level";
    }

    if (!selectedLanguage || selectedLanguage.length <= 0) {
      isValidation = true;
      dummyErrors.selectedLanguage = "Please select language";
    }

    if (!skills || skills.length <= 0) {
      isValidation = true;
      dummyErrors.skills = "Please enter skills";
    }

    if (!primary || primary.length <= 0) {
      isValidation = true;
      dummyErrors.primary = "Please select primary image";
    }

    if (!banner || banner.length <= 0) {
      isValidation = true;
      dummyErrors.banner = "Please select banner";
    }

    // if (!intro || intro.length <= 0) {
    //   isValidation = true;
    //   dummyErrors.intro = "Please select intro media";
    // }

    // if (!media || media.length <= 0) {
    //   isValidation = true;
    //   dummyErrors.media = "Please select at least one media";
    // }

    if (!benefits || benefits.length <= 0) {
      isValidation = true;
      dummyErrors.benefits = "Please add at least one benefit";
    } else if (benefits.length >= 1) {
      benefits.map((item, index) => {
        dummyErrors.benefits[index] = {
          name: "",
          short_description: "",
          icon_name: "",
        };
        if (!item.name) {
          isValidation = true;
          dummyErrors.benefits[index]["name"] = "Please enter name";
        }
        if (!item.short_description) {
          isValidation = true;
          dummyErrors.benefits[index]["short_description"] =
            "Please enter short description";
        }
        if (!item.icon_name) {
          isValidation = true;
          dummyErrors.benefits[index]["icon_name"] = "Please select icon";
        }
      });
    }

    console.log("dummyErrors dummyErrors", dummyErrors);

    this.setState({
      errors: dummyErrors,
    });

    if (isValidation) {
      return;
    }

    values.long_description = longDescription;
    values.media = [primary, banner];
    values.category_id = selectedCategoryType;
    values.sub_categories = selectedSubCategoryType.map((item) => ({
      sub_category_id: item,
    }));
    values.is_paid = isPaid;
    if (!isPaid) {
      values.price = 0;
    } else {
      values.price = (values.price !== undefined && values.price !== "") ? Number(values.price) : 0;
    }
    values.is_age_restricted = isRestricted;
    values.age_restriction_count = isRestricted
      ? parseInt(values.age_restriction_count, 10) || 0
      : 0;
    values.is_certified = isCertified;
    values.certificate_template_id = isCertified
      ? this.state.selectedCertificateTemplateId
      : null;
    values.is_featured = isFeatured;
    values.difficulty_level = selectedDiffLevel;
    values.validity = parseInt(selectedValidity, 10) || 365;
    values.languages = selectedLanguage.map((item) => ({
      language_id: item,
    }));
    values.skills = this.skills;
    values.benefits = benefits;

    console.log("for sumitssion values", values);

    this.props.onSubmit(values);

    this.setState({
      visible: false,
      isShouldComponentUpdate: false,
      viewBannerModal: false,
      viewIntroModal: false,
      viewPrimaryModal: false,
      viewMediaModal: false,
      viewBenefitIconModal: false,
      isLoading: false,
      selectedCategoryType: "",
      selectedDiffLevel: "",
      selectedValidity: "",
      selectedValidityDate: null,
      validityOpen: false,
      selectedSubCategoryType: [],
      isPaid: false,
      isRestricted: false,
      isCertified: false,
      isFeatured: false,
      categoryList: [],
      skills: [],
      languages: [],
      inputFields: [],
      benefits: [],
      mediaFields: [],
      primary: [],
      media: [],
      banner: [],
      intro: [],
      selectedLanguage: [],
      allSubCategories: [],
      longDescription: null,
      errors: {},
    });
  };

  changeCategoryType = (value) => {
    let updateState = {
      selectedCategoryType: value,
    };
    if (value && this.allCategories) {
      const selectedCatObj = this.allCategories.find(
        (c) => c.value === value || c._id === value
      );
      if (selectedCatObj && selectedCatObj.label) {
        const catNameLower = selectedCatObj.label.toLowerCase().trim();
        if (catNameLower === "free") {
          updateState.isPaid = false;
        } else if (catNameLower === "paid") {
          updateState.isPaid = true;
        }
      }
    }
    this.setState(updateState);
    //get sub category from the category ID start
    this.getSubCategoriesFromCategory(value);
    //get sub category from the category ID end
  };

  changeSubCategoryType = (value) => {
    this.setState({
      selectedSubCategoryType: value,
    });
  };

  onChangeIsPaid() {
    const nextIsPaid = !this.state.isPaid;
    let updateState = {
      isPaid: nextIsPaid,
    };

    if (this.allCategories && this.allCategories.length > 0) {
      const targetCategoryName = nextIsPaid ? "paid" : "free";
      const matchedCategory = this.allCategories.find(
        (c) => c.label && c.label.toLowerCase().trim() === targetCategoryName
      );
      if (matchedCategory) {
        updateState.selectedCategoryType = matchedCategory.value;
        this.getSubCategoriesFromCategory(matchedCategory.value);
      }
    }

    this.setState(updateState);
  }

  getSubCategoriesFromCategory = async (categoryId) => {
    const { authToken } = this.props;

    this.allSubCategories = [];

    if (categoryId) {
      let subCategoriesData = await listSubCategoryFromCategory(
        authToken,
        categoryId,
        0,
        1000000
      );

      if (subCategoriesData.data && subCategoriesData.data.length >= 1) {
        subCategoriesData.data.forEach((data) => {
          this.allSubCategories.push({
            value: data._id,
            label: data.name,
          });
        });
      }
    }

    this.setState({
      allSubCategories: this.allSubCategories,
    });
  };

  changeDiffiLevel = (value) => {
    this.setState({
      selectedDiffLevel: value,
    });
  };

  changeValidity = (value, date) => {
    this.setState({
      selectedValidity: value,
      selectedValidityDate: date,
    });
  };

  changeLanguage = (value) => {
    this.setState({
      selectedLanguage: value,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
      isShouldComponentUpdate: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedCategoryType: "",
      media: [],
      primary: [],
      banner: [],
      intro: [],
      errors: {},
      isShouldComponentUpdate: false,
    });
  };

  handleChange(value) {
    console.log(`selected ${value}`);
    amenities = value;
  }

  addBenefits = () => {
    const { benefits } = this.state;
    let dummyQuesions = benefits;
    dummyQuesions.push({
      name: "",
      short_description: "",
      icon_name: "",
      view_benefit_icon_modal: false,
    });

    this.setState({
      benefits: dummyQuesions,
    });
  };

  removeBenefitItem = (index) => {
    const { benefits } = this.state;
    let dummyQuesions = benefits;
    dummyQuesions.splice(index, 1);

    this.setState({
      benefits: dummyQuesions,
    });
  };

  uploadBenefitIconMedia = (name, blobUrl, index) => {
    const { benefits } = this.state;
    let dummyQuesions = benefits;
    dummyQuesions[index]["icon_name"] = name;
    dummyQuesions[index]["blobUrl"] = blobUrl;
    dummyQuesions[index]["view_benefit_icon_modal"] = false;
    this.setState({
      benefits: dummyQuesions,
    });
  };

  onQuestionValueChange = (e, index) => {
    const { benefits } = this.state;
    let dummyQuesions = benefits;
    dummyQuesions[index][e.target.name] = e.target && e.target.value;
    this.setState({
      benefits: dummyQuesions,
    });
  };

  viewQuestionImageModalRef;

  showQuestionImageUpload(index) {
    const { benefits } = this.state;
    let dummyQuesions = benefits;
    dummyQuesions[index]["view_benefit_icon_modal"] = true;
    this.setState(
      {
        benefits: dummyQuesions,
      },
      () => {
        this.viewQuestionImageModalRef.show();
      }
    );
  }

  handleChangeSkills = (skills) => {
    const formatted = (skills || []).map((skill) => skill.trim()).filter(Boolean);
    this.skills = formatted.map((skill) => ({ name: skill }));
    this.setState({ skills: formatted });
  };

  //for input change in benefits
  handleChangeInput = (index, event) => {
    const values = [...this.state.inputFields];
    values[index][event.target.name] = event.target.value;
    values[index][event.target.short_description] = event.target.value;
    this.setState({ inputFields: values });
  };

  //file icon change

  handleChangeFileInput = (index, event) => {
    console.log("hey there", event.target.files[0]);
    const values = [...this.state.inputFields];

    values[index]["icon_name"] = event.target.files[0];
    this.setState({ inputFields: values });
  };

  uploadBenefitIcon = (name, index) => {
    console.log("!!!!!!!!!!!!!!after upload ", name);
    console.log("!!!!!!!!!!!!!!beniifit section", this.state.inputFields);
    if (name != null) {
      console.log("index benefit icon", index);
      this.src[index] = name;
      this.setState({
        viewBenefitIconModal: false,
      });
      //set benefit icon name into form field
      const values = [...this.state.inputFields];
      values[index]["icon_name"] = name;
    } else {
      this.setState({
        viewBenefitIconModal: false,
      });
    }
  };

  // uploadMediaFiles = (mediaData) => {
  //   console.log("!!!!!!!!!!!!!!after upload 1111111 ", mediaData);
  //   if (mediaData && mediaData.length > 0) {
  //     this.setState({
  //       media: [...this.state.media, ...mediaData],
  //       viewMediaModal: false
  //     });
  //   } else {
  //     this.setState({
  //       viewMediaModal: false
  //     });
  //   }
  // }

  uploadBanner = (name, bannerData) => {
    console.log("!!!!!!!!!!!!!!after upload ", name);
    if (name != null) {
      // this.bannerSrc = bannerData;
      this.setState({
        banner: bannerData,
        viewBannerModal: false,
      });
    } else {
      this.setState({
        viewBannerModal: false,
      });
    }
  };

  uploadPrimary = (name, primaryData) => {
    console.log("!!!!!!!!!!!!!!after upload ", name);
    if (name != null) {
      this.setState({
        primary: primaryData,
        viewPrimaryModal: false,
      });
    } else {
      this.setState({
        viewPrimaryModal: false,
      });
    }
  };

  // uploadIntro = (name, introData) => {
  //   console.log("!!!!!!!!!!!!!!after upload ", name);
  //   if (name != null) {
  //     this.setState({
  //       intro: introData,
  //       viewIntroModal: false,
  //     });
  //   } else {
  //     this.setState({
  //       viewIntroModal: false,
  //     });
  //   }
  // };

  //for dynamically adding benefit
  addNewBenefit = () => {
    this.setState({
      inputFields: [
        ...this.state.inputFields,
        {
          name: "",
          short_description: "",
          icon_name: null,
        },
      ],
    });
  };

  // addNewMedia = () => {
  //   this.setState({
  //     mediaFields: [...this.state.mediaFields, {
  //       'media_type': "",
  //       'type': "",
  //       'media_name': ""
  //     }]
  //   })
  // }

  showBannerModal(params) {
    this.setState(
      {
        viewBannerModal: true,
      },
      () => {
        this.viewBannerModalRef.show();
      }
    );
  }

  showPrimaryModal(params) {
    this.setState(
      {
        viewPrimaryModal: true,
      },
      () => {
        this.viewPrimaryModalRef.show();
      }
    );
  }

  showIntroModal(params) {
    this.setState(
      {
        viewIntroModal: true,
      },
      () => {
        this.viewIntroModalRef.show();
      }
    );
  }

  showMediaModal(params) {
    this.setState(
      {
        viewMediaModal: true,
      },
      () => {
        this.viewMediaModalRef.show();
      }
    );
  }

  showBenefitIconModal(params) {
    this.setState(
      {
        viewBenefitIconModal: true,
      },
      () => {
        this.viewBenefitIconModalRef.show();
      }
    );
  }

  onChangeIsRestricted() {
    this.setState({
      isRestricted: !this.state.isRestricted,
    });
  }

  onChangeIsCertified() {
    this.setState({
      isCertified: !this.state.isCertified,
    });
  }

  onChangeIsFeatured() {
    this.setState({
      isFeatured: !this.state.isFeatured,
    });
  }

  onLongDescEditorChange = (value) => {
    this.setState({ longDescription: value });
  };

  render() {
    const { primaryColor, loginData } = this.props;
    const {
      isPaid,
      isRestricted,
      isCertified,
      isFeatured,
      benefits,
      media,
      primary,
      banner,
      intro,
      skills,
      longDescription,
      selectedCategoryType,
      selectedSubCategoryType,
      selectedDiffLevel,
      selectedLanguage,
    } = this.state;

    // console.log(loginData);
    // console.log(loginData.permissions.users.create);
    const hasPermission = checkPermission(loginData, "course", "create");

    return (
      <div>
        <div
          onClick={hasPermission ? this.showModal : null}
          style={{
            width: "100px",
            backgroundColor: primaryColor,
            color: "white",
            padding: "7px 0px",
            textAlign: "center",
            borderRadius: "50px",
            cursor: hasPermission ? "pointer" : "not-allowed",
            opacity: hasPermission ? 1 : 0.5,
            pointerEvents: hasPermission ? "auto" : "none",
          }}
        >
          ADD
        </div>
        <CustomModal
          width="1000px"
          visible={this.state.visible}
          title="Add Course"
          onClose={this.handleCancel}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                name: "",
                author: "",
                short_description: "",
                long_description: "",
                summary_description: "",
                price: "",
                total_time: "",
                category_id: "",
                is_paid: false,
                is_age_restricted: false,
                age_restriction_count: "",
                skills: this.state.skills,
                languages: this.state.languages,
                benefits: this.state.inputFields,
                passing_marks: "",
              }}
              // enableReinitialize
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Name
                        <Input
                          id="name"
                          placeholder="Name"
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.name && touched.name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.name}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Author
                        <Input
                          id="author"
                          placeholder="Author"
                          value={values.author}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.author && touched.author ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.author}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field">
                        Short Description
                        <TextArea
                          row={4}
                          id="short_description"
                          placeholder="Short Description"
                          value={values.short_description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.short_description &&
                          touched.short_description ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.short_description}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field">
                        About Course
                        <CKEditorField
                          id="about-course-editor"
                          value={longDescription}
                          onChange={this.onLongDescEditorChange}
                          onBlur={handleBlur}
                          uploadUrl={COURSE_BANNER_UPLOAD_PATH}
                          uploadPreviewUrl={COURSE_BANNER_PREVIEW_PATH}
                        />
                        {errors.long_description && touched.long_description ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.long_description}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field">
                        Summary
                        <TextArea
                          row={4}
                          id="summary_description"
                          placeholder="Summary"
                          value={values.summary_description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.summary_description &&
                          touched.summary_description ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.summary_description}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Category
                        <CustomSelect
                          style={{ width: "100%" }}
                          onChange={(value) => this.changeCategoryType(value)}
                          placeholder="Select Category"
                          showSearch={true}
                          value={selectedCategoryType}
                          options={this.allCategories}
                        />
                        {this.state.errors.selectedCategoryType ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedCategoryType}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Sub Category
                        <CustomSelect
                          mode="multiple"
                          style={{ width: "100%" }}
                          onChange={(value) =>
                            this.changeSubCategoryType(value)
                          }
                          placeholder="Select Sub Category"
                          showSearch={true}
                          value={selectedSubCategoryType}
                          options={this.state.allSubCategories}
                        />
                        {this.state.errors.selectedSubCategoryType ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedSubCategoryType}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Validity
                        <CustomDatePicker
                          style={{ width: "100%" }}
                          placeholder="Select Validity Date"
                          value={this.state.selectedValidityDate}
                          onChange={(date, dateString) => {
                            if (date) {
                              const validity = Math.max(
                                1,
                                date.clone().startOf("day").diff(moment().startOf("day"), "days")
                              );
                              console.log("Validity:", validity);
                              this.changeValidity(validity, date);
                            } else {
                              this.changeValidity("", null);
                            }
                          }}
                          disabledDate={(current) =>
                            current && current < moment().endOf("day")
                          }
                        />
                        {this.state.errors.selectedValidity ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedValidity}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Difficulty Level
                        <CustomSelect
                          style={{ width: "100%" }}
                          onChange={(value) => this.changeDiffiLevel(value)}
                          placeholder="Select Difficulty Level Type"
                          value={selectedDiffLevel}
                          options={this.difficultyLevelTypes}
                        />
                        {this.state.errors.selectedDiffLevel ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedDiffLevel}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Skills
                        <TagsInput
                          value={skills}
                          onChange={this.handleChangeSkills}
                          onlyUnique={true}
                          placeholder="Skills"
                        />
                        {this.state.errors.skills ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.skills}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Language
                        <CustomSelect
                          mode="multiple"
                          style={{ width: "100%" }}
                          onChange={(value) => this.changeLanguage(value)}
                          placeholder="Select Language"
                          showSearch={true}
                          value={selectedLanguage}
                          options={this.allLanguages}
                        />
                        {this.state.errors.selectedLanguage ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.selectedLanguage}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Total Time
                        <Input
                          id="total_time"
                          placeholder="Total Time"
                          value={values.total_time}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d+$/.test(val)) {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.total_time && touched.total_time ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.total_time}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        <Checkbox
                          onChange={(value) => this.onChangeIsFeatured()}
                          checked={isFeatured}
                        >
                          is Featured?
                        </Checkbox>
                        {this.state.errors.isFeatured ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.isFeatured}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        <Checkbox
                          onChange={(value) => this.onChangeIsPaid()}
                          checked={isPaid}
                        >
                          is Paid?
                        </Checkbox>
                        {this.state.errors.isPaid ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.isPaid}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Price
                        <Input
                          id="price"
                          placeholder="Price"
                          value={values.price}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={!isPaid}
                        />
                        {errors.price && touched.price ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.price}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        <Checkbox
                          onChange={(value) => this.onChangeIsRestricted()}
                          checked={isRestricted}
                        >
                          Is Age Restricted?
                        </Checkbox>
                        {this.state.errors.isRestricted ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.isRestricted}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Restricted Age
                        <Input
                          id="age_restriction_count"
                          placeholder="Restricted Age"
                          value={values.age_restriction_count}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={!isRestricted}
                        />
                        {errors.age_restriction_count &&
                          touched.age_restriction_count ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.age_restriction_count}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        <Checkbox
                          onChange={(value) => this.onChangeIsCertified()}
                          checked={isCertified}
                        >
                          is Certified?
                        </Checkbox>
                        {isCertified && (
                          <div style={{ marginTop: "10px" }}>
                            <label style={{ fontSize: "12px", display: "block", marginBottom: "4px" }}>
                              Certificate Template:
                            </label>
                            <Select
                              style={{ width: "100%" }}
                              placeholder="Select Certificate Template"
                              value={this.state.selectedCertificateTemplateId}
                              onChange={(val) => this.setState({ selectedCertificateTemplateId: val })}
                            >
                              {this.state.certificateTemplates.map((t) => (
                                <Option key={t._id} value={t._id}>
                                  {t.title} {t.is_default ? "(Default)" : ""}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        )}
                        {this.state.errors.isCertified ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {this.state.errors.isCertified}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        Passing Marks
                        <InputNumber
                          id="passing_marks"
                          type="number"
                          placeholder="Passing Marks"
                          value={values.passing_marks}
                          onChange={(value) => {
                            if (!isNaN(value)) {
                              console.log("passing_marks", { value });
                              setFieldValue("passing_marks", value);
                            }
                          }}
                          onBlur={handleBlur}
                          // min={0}
                          // max={100}
                          style={{ width: "100%" }}
                        />
                        {errors.passing_marks && touched.passing_marks ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.passing_marks}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <Divider></Divider>

                    {/* Course Primary Media Section Start */}

                    {/* Course Primary Media Section Start */}
                    <div style={{ marginTop: "20px", width: "100%" }}>
                      <div style={{ marginBottom: "8px", fontWeight: "600", fontSize: "14px", color: "#262626" }}>
                        Course Primary Media
                      </div>
                      <div
                        onClick={this.showPrimaryModal.bind(this)}
                        style={{
                          border: "2px dashed #d9d9d9",
                          borderRadius: "8px",
                          padding: "24px",
                          textAlign: "center",
                          cursor: "pointer",
                          backgroundColor: "#fafafa",
                          transition: "all 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = primaryColor || "#1890ff";
                          e.currentTarget.style.backgroundColor = "#f0f7ff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#d9d9d9";
                          e.currentTarget.style.backgroundColor = "#fafafa";
                        }}
                      >
                        {primary && primary.media_name ? (
                          <div style={{ position: "relative", display: "inline-block", maxWidth: "100%" }}>
                            <img
                              src={primary.blobUrl || `${COURSE_PRIMARY_PREVIEW_PATH}${primary.media_name}`}
                              alt="Primary Preview"
                              style={{ maxHeight: "150px", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.12)", objectFit: "contain" }}
                            />
                            <div style={{ marginTop: "12px", color: "#595959", fontSize: "13px", wordBreak: "break-all", fontWeight: "500" }}>
                              {primary.media_name}
                            </div>
                            <div
                              style={{
                                marginTop: "6px",
                                color: primaryColor || "#1890ff",
                                fontWeight: "600",
                                fontSize: "13px"
                              }}
                            >
                              Click to change primary media
                            </div>
                          </div>
                        ) : (
                          <div style={{ padding: "10px 0" }}>
                            <PictureOutlined style={{ fontSize: "36px", color: "#bfbfbf", marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", fontWeight: "600", color: "#434343" }}>
                              Click to select primary media
                            </div>
                            <div style={{ fontSize: "12px", color: "#8c8c8c", marginTop: "6px" }}>
                              Supports PNG, JPEG, JPG, GIF
                            </div>
                          </div>
                        )}
                      </div>

                      {this.state.errors.primary ? (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            margin: "0",
                            marginTop: "6px"
                          }}
                        >
                          {this.state.errors.primary}
                        </p>
                      ) : null}

                      {this.state.viewPrimaryModal ? (
                        <AddCoursePrimaryMedia
                          refx={(e) => (this.viewPrimaryModalRef = e)}
                          onUpload={this.uploadPrimary}
                        />
                      ) : null}
                    </div>
                    {/* Course Primary Media Section End */}

                    <Divider></Divider>

                    {/* Course Banner Image Section Start */}
                    <div style={{ marginTop: "20px", width: "100%" }}>
                      <div style={{ marginBottom: "8px", fontWeight: "600", fontSize: "14px", color: "#262626" }}>
                        Course Banner Image
                      </div>
                      <div
                        onClick={this.showBannerModal.bind(this)}
                        style={{
                          border: "2px dashed #d9d9d9",
                          borderRadius: "8px",
                          padding: "24px",
                          textAlign: "center",
                          cursor: "pointer",
                          backgroundColor: "#fafafa",
                          transition: "all 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = primaryColor || "#1890ff";
                          e.currentTarget.style.backgroundColor = "#f0f7ff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#d9d9d9";
                          e.currentTarget.style.backgroundColor = "#fafafa";
                        }}
                      >
                        {banner && banner.media_name ? (
                          <div style={{ position: "relative", display: "inline-block", maxWidth: "100%" }}>
                            <img
                              src={banner.blobUrl || `${COURSE_BANNER_PREVIEW_PATH}${banner.media_name}`}
                              alt="Banner Preview"
                              style={{ maxHeight: "120px", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.12)", objectFit: "contain" }}
                            />
                            <div style={{ marginTop: "12px", color: "#595959", fontSize: "13px", wordBreak: "break-all", fontWeight: "500" }}>
                              {banner.media_name}
                            </div>
                            <div
                              style={{
                                marginTop: "6px",
                                color: primaryColor || "#1890ff",
                                fontWeight: "600",
                                fontSize: "13px"
                              }}
                            >
                              Click to change banner image
                            </div>
                          </div>
                        ) : (
                          <div style={{ padding: "10px 0" }}>
                            <PictureOutlined style={{ fontSize: "36px", color: "#bfbfbf", marginBottom: "12px" }} />
                            <div style={{ fontSize: "14px", fontWeight: "600", color: "#434343" }}>
                              Click to select banner image
                            </div>
                            <div style={{ fontSize: "12px", color: "#8c8c8c", marginTop: "6px" }}>
                              Recommended Ratio: 1920 X 600 (PNG, JPEG, JPG, GIF)
                            </div>
                          </div>
                        )}
                      </div>

                      {this.state.errors.banner ? (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            margin: "0",
                            marginTop: "6px"
                          }}
                        >
                          {this.state.errors.banner}
                        </p>
                      ) : null}

                      {this.state.viewBannerModal ? (
                        <AddCourseBanner
                          refx={(e) => (this.viewBannerModalRef = e)}
                          onUpload={this.uploadBanner}
                        />
                      ) : null}
                    </div>
                    {/* Course Banner Image Section End */}

                    <Divider></Divider>

                    {/* Course Intro Media Section Start */}

                    {/* <div
                      style={{
                        display: "inline-block",
                        width: "100%",
                        marginTop: "20px",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ float: "left", width: "10%" }}>
                        <PictureOutlined
                          style={{ width: "100%", fontSize: "30px" }}
                        />
                      </div>
                      <Button
                        style={{ width: "90%" }}
                        onClick={this.showIntroModal.bind(this)}
                      >
                        Choose Course Intro Media
                      </Button>

                      {this.state.errors.intro ? (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            margin: "0",
                          }}
                        >
                          {this.state.errors.intro}
                        </p>
                      ) : null}

                      {this.state.viewIntroModal ? (
                        <AddCourseIntroMedia
                          refx={(e) => (this.viewIntroModalRef = e)}
                          onUpload={this.uploadIntro}
                        />
                      ) : null}
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        width: "100%",
                        backgroundColor:
                          this.selectedColorType !== ""
                            ? this.selectedColorType
                            : "#ffffff",
                        borderRadius: "10px",
                      }}
                    >
                      {intro && intro.thumb_media_name ? (
                        <MediaItem
                          name={intro.media_name}
                          url={`${COURSE_INTRO_PREVIEW_PATH}${intro.media_name}`}
                          thumbMediaUrl={`${COURSE_INTRO_PREVIEW_PATH}${intro.thumb_media_name}`}
                        />
                      ) : null}
                    </div> */}

                    {/* Course Intro Media Section End */}

                    {/* <Divider></Divider> */}

                    {/* Course Media Section Start */}

                    {/* <div className="formik-field_wrap">
                      <div className="formik-field">
                        {/* <label><strong><Divider orientation="left">Media</Divider></strong></label> */}
                    {/* <div className="formik-field-wrap">

                          <div style={{ display: "inline-block", width: "100%", marginTop: "20px", alignItems: "center" }}>
                            <div style={{ float: "left", width: "10%" }}>
                              <PictureOutlined style={{ width: "100%", fontSize: "30px" }} />
                            </div>
                            <Button style={{ width: "90%" }} onClick={this.showMediaModal.bind(this)} >
                              Choose Media Files
                            </Button>

                            {this.state.errors.media ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {this.state.errors.media}
                              </p>
                            ) : null}

                            {media && media.length > 0 ? (
                              media.map(media =>
                                <p style={{ fontSize: "small", margin: "0", marginLeft: "5px" }} key={media.media_name}>
                                  {media.media_name}
                                </p>
                              )
                            ) : null}
                            {this.state.viewMediaModal ? (
                              <AddCourseMediaFiles refx={(e) => (this.viewMediaModalRef = e)} onUpload={this.uploadMediaFiles} />
                            ) : null}
                          </div>

                          <div width="100%" style={{ marginTop: "10px" }}>
                            {this.state.errors.uploadMedia != "" ? (
                              <p style={{ color: "red", fontSize: "small", margin: "0" }}>
                                {this.state.errors.uploadMedia}
                              </p>
                            ) : null}
                          </div>

                          <div style={{ marhinTop: "20px", width: "100px", backgroundColor: this.selectedColorType !== "" ? this.selectedColorType : "#ffffff", borderRadius: "10px" }}>
                            <div className="row">
                              {media && media.length > 0 ? (
                                media.map((media) =>
                                  <div className="col-2">
                                    <img src={`${WEBURL}course/${media.media_name}`} alt="Media" style={{ width: "100px" }} key={media.media_name} />
                                  </div>
                                )
                              ) : null}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div> */}

                    {/* Course Media Section End */}

                    {/* <Divider></Divider> */}

                    {/* Course Benefit Section Start */}
                    <>
                      <div style={{ marginTop: "15px" }}>
                        <Button
                          style={{
                            marginTop: "19px",
                            background: "#5C6AC4",
                            color: "#fff",
                          }}
                          onClick={() => this.addBenefits()}
                        >
                          Add Benefit
                        </Button>
                      </div>

                      <div style={{ marginTop: "15px" }}>
                        {benefits.map((data, index) => {
                          return (
                            <div
                              style={{
                                marginBottom: "15px",
                                display: "inline-block",
                                width: "100%",
                                paddingBottom: "15px",
                                borderBottom: "4px dashed gray",
                              }}
                              key={index}
                            >
                              <div
                                style={{
                                  marginTop: "5px",
                                  marginBottom: "5px",
                                  width: "100%",
                                  display: "inline-block",
                                }}
                              >
                                <span
                                  style={{ fontWeight: "bold", float: "left" }}
                                >
                                  {`Benefit ${index + 1}`}
                                </span>
                                <span
                                  style={{ fontWeight: "bold", float: "right" }}
                                >
                                  <Button
                                    shape="circle"
                                    icon={<DeleteFilled />}
                                    onClick={() => {
                                      this.removeBenefitItem(index);
                                    }}
                                  />
                                </span>
                              </div>

                              <div className="formik-field_wrap custom30Width">
                                <div className="formik-field_wrap">
                                  <div className="formik-field">
                                    <span style={{ fontWeight: "bold" }}>
                                      Name
                                    </span>
                                    <Input
                                      id="text"
                                      placeholder="Text"
                                      name="name"
                                      value={benefits[index]["name"]}
                                      onChange={(e) =>
                                        this.onQuestionValueChange(e, index)
                                      }
                                      onBlur={handleBlur}
                                    />
                                    {this.state.errors.benefits &&
                                      this.state.errors.benefits[index] &&
                                      this.state.errors.benefits[index][
                                      "name"
                                      ] ? (
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "small",
                                          margin: "0",
                                        }}
                                      >
                                        {
                                          this.state.errors.benefits[index][
                                          "name"
                                          ]
                                        }
                                      </p>
                                    ) : null}
                                  </div>
                                </div>

                                <div className="formik-field_wrap">
                                  <div className="formik-field">
                                    <span style={{ fontWeight: "bold" }}>
                                      Short Description
                                    </span>
                                    <TextArea
                                      row={4}
                                      id="short_description"
                                      placeholder="Short Description"
                                      name="short_description"
                                      value={
                                        benefits[index]["short_description"]
                                      }
                                      onChange={(e) =>
                                        this.onQuestionValueChange(e, index)
                                      }
                                      onBlur={handleBlur}
                                    />
                                    {this.state.errors.benefits &&
                                      this.state.errors.benefits[index] &&
                                      this.state.errors.benefits[index][
                                      "short_description"
                                      ] ? (
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "small",
                                          margin: "0",
                                        }}
                                      >
                                        {
                                          this.state.errors.benefits[index][
                                          "short_description"
                                          ]
                                        }
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              {/* Course Benefit Media Section Start */}

                              <div
                                className="formik-field_wrap"
                                style={{ marginTop: "15px" }}
                              >
                                <div className="formik-field" style={{ width: "100%" }}>
                                  <div style={{ marginBottom: "6px", fontWeight: "500", fontSize: "13px", color: "#595959" }}>
                                    Benefit Icon
                                  </div>
                                  <div
                                    onClick={this.showQuestionImageUpload.bind(this, index)}
                                    style={{
                                      border: "2px dashed #d9d9d9",
                                      borderRadius: "6px",
                                      padding: "16px",
                                      textAlign: "center",
                                      cursor: "pointer",
                                      backgroundColor: "#fafafa",
                                      transition: "all 0.3s",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.borderColor = primaryColor || "#1890ff";
                                      e.currentTarget.style.backgroundColor = "#f0f7ff";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.borderColor = "#d9d9d9";
                                      e.currentTarget.style.backgroundColor = "#fafafa";
                                    }}
                                  >
                                    {benefits[index]["icon_name"] ? (
                                      <div style={{ position: "relative", display: "inline-block", maxWidth: "100%" }}>
                                        <img
                                          src={benefits[index]["blobUrl"] || `${COURSE_BENEFIT_PREVIEW_PATH}${benefits[index]["icon_name"]}`}
                                          alt="Benefit Icon Preview"
                                          style={{ maxHeight: "60px", borderRadius: "4px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", objectFit: "contain" }}
                                        />
                                        <div style={{ marginTop: "8px", color: "#595959", fontSize: "12px", wordBreak: "break-all" }}>
                                          {benefits[index]["icon_name"]}
                                        </div>
                                        <div
                                          style={{
                                            marginTop: "4px",
                                            color: primaryColor || "#1890ff",
                                            fontWeight: "600",
                                            fontSize: "12px"
                                          }}
                                        >
                                          Click to change icon
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <PictureOutlined style={{ fontSize: "24px", color: "#bfbfbf", marginBottom: "8px" }} />
                                        <div style={{ fontSize: "13px", fontWeight: "600", color: "#434343" }}>
                                          Click to select benefit icon
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {this.state.errors.benefits &&
                                    this.state.errors.benefits[index] &&
                                    this.state.errors.benefits[index][
                                    "icon_name"
                                    ] ? (
                                    <p
                                      style={{
                                        color: "red",
                                        fontSize: "small",
                                        margin: "0",
                                        marginTop: "6px"
                                      }}
                                    >
                                      {
                                        this.state.errors.benefits[index][
                                        "icon_name"
                                        ]
                                      }
                                    </p>
                                  ) : null}

                                  {benefits[index][
                                    "view_benefit_icon_modal"
                                  ] ? (
                                    <AddCourseBenefitsIcon
                                      refx={(e) =>
                                        (this.viewQuestionImageModalRef = e)
                                      }
                                      onUpload={(name, blobUrl) =>
                                        this.uploadBenefitIconMedia(name, blobUrl, index)
                                      }
                                      selectedMediaType={"question"}
                                    />
                                  ) : null}
                                </div>
                              </div>
                              {/* Course Benefit Media Section End */}
                            </div>
                          );
                        })}
                      </div>
                      {this.state.errors.benefits &&
                        typeof this.state.errors.benefits === "string" ? (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            margin: "0",
                          }}
                        >
                          {this.state.errors.benefits}
                        </p>
                      ) : null}
                    </>

                    {/* Course Benefit Section End */}

                    <Button
                      type="primary"
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Add
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}

export default connect()(withRouter(AddCourse));
